import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import { Quote, Star } from 'lucide-react';

// Styles Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Reviews = () => {
  const individualReviews = [
    { id: 1, name: "Julien M.", stars: 5, text: "Service de dépannage ultra rapide et efficace ! Christophe a résolu mon problème en un rien de temps. Très professionnel, je recommande les yeux fermés.", visitDate: "avril 2025" },
    { id: 2, name: "Sophie L.", stars: 5, text: "Excellent accueil et très bon diagnostic pour ma voiture. Les réparations ont été faites dans les délais annoncés et le tarif était correct. Garage de confiance à Lahage.", visitDate: "mars 2025" },
    { id: 3, name: "Alain B.", stars: 5, text: "Christophe est un mécanicien compétent et honnête. Il prend le temps d'expliquer les interventions. En plus, l'ouverture 24h/24 est un vrai atout.", visitDate: "février 2025" },
    { id: 4, name: "Carine D.", stars: 5, text: "Révision annuelle effectuée chez Christophe Dépanne. Travail soigné, conseils avisés et toujours avec le sourire. Je suis très satisfaite.", visitDate: "janvier 2025" },
    { id: 5, name: "Team Découverte31", stars: 5, text: "Un grand merci à Christophe pour son intervention un dimanche ! Professionnel, réactif et sympathique. C'est rassurant de savoir qu'on peut compter sur un tel service à Lahage.", visitDate: "décembre 2024" }
  ];

  return (
    <section className="reviews-section">
      <div className="container">
        <div className="reviews-header">
          <span className="badge">Témoignages</span>
          <h2 className="title">Ce que disent <span>nos clients</span></h2>
          <div className="google-trust">
            <div className="stars">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#f59e0b" color="#f59e0b" />)}
            </div>
            <span>4.9/5 sur Google Reviews</span>
          </div>
        </div>

        <div className="swiper-container">
          <Swiper
            modules={[Navigation, Pagination, A11y, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            loop={true}
            breakpoints={{
              640: { slidesPerView: 1 },
              1024: { slidesPerView: 2 },
              1280: { slidesPerView: 3 },
            }}
            className="reviews-swiper"
          >
            {individualReviews.map(review => (
              <SwiperSlide key={review.id}>
                <div className="review-card">
                  <div className="quote-icon">
                    <Quote size={40} fill="#3b82f6" color="#3b82f6" opacity={0.1} />
                  </div>
                  <div className="card-header">
                    <div className="stars">
                      {[...Array(review.stars)].map((_, i) => <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />)}
                    </div>
                    <span className="date">{review.visitDate}</span>
                  </div>
                  <p className="review-text">"{review.text}"</p>
                  <div className="author-info">
                    <div className="avatar">
                      {review.name.charAt(0)}
                    </div>
                    <strong>{review.name}</strong>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style jsx>{`
        .reviews-section {
          padding: 120px 0;
          background: #f1f5f9;
          position: relative;
        }

        .container {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .reviews-header {
          text-align: center;
          margin-bottom: 80px;
        }

        .badge {
          display: inline-block;
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
          padding: 6px 18px;
          border-radius: 50px;
          font-weight: 800;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 25px;
        }

        .title {
          font-size: 3.5rem;
          color: #1e293b;
          font-weight: 900;
          margin-bottom: 20px;
        }

        .title span {
          color: #3b82f6;
        }

        .google-trust {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        .google-trust .stars {
          display: flex;
          gap: 5px;
        }

        .google-trust span {
          color: #64748b;
          font-weight: 600;
          font-size: 1rem;
        }

        .swiper-container {
          padding: 20px 0 60px;
        }

        .review-card {
          background: #ffffff !important;
          padding: 40px;
          border-radius: 32px;
          height: 100%;
          box-shadow: 0 10px 40px rgba(0,0,0,0.05);
          border: 1px solid #e2e8f0;
          position: relative;
          display: flex;
          flex-direction: column;
          transition: all 0.4s ease;
        }

        .review-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 30px 60px rgba(0,0,0,0.1);
          border-color: #3b82f6;
        }

        .quote-icon {
          position: absolute;
          top: 35px;
          right: 35px;
        }

        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
        }

        .card-header .stars {
          display: flex;
          gap: 4px;
        }

        .date {
          font-size: 0.9rem;
          color: #64748b;
          font-weight: 700;
        }

        .review-text {
          font-size: 1.2rem;
          line-height: 1.6;
          color: #000000;
          font-weight: 500;
          font-style: italic;
          margin-bottom: 40px;
          flex-grow: 1;
        }

        .author-info {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .avatar {
          width: 50px;
          height: 50px;
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 900;
          font-size: 1.3rem;
        }

        .author-info strong {
          color: #000000;
          font-size: 1.2rem;
          font-weight: 800;
        }

        :global(.swiper-pagination-bullet-active) {
          background: #3b82f6 !important;
          width: 25px !important;
          border-radius: 5px !important;
        }

        :global(.swiper-button-next), :global(.swiper-button-prev) {
          color: #3b82f6 !important;
          background: white;
          width: 50px !important;
          height: 50px !important;
          border-radius: 50%;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }

        :global(.swiper-button-next:after), :global(.swiper-button-prev:after) {
          font-size: 1.2rem !important;
          font-weight: 900;
        }

        @media (max-width: 768px) {
          .title { font-size: 2.5rem; }
          .review-card { padding: 30px; }
          .reviews-section { padding: 80px 0; }
        }
      `}</style>
    </section>
  );
};

export default Reviews;
